import { monthMap } from "./constants";

const fileToDataURL = (file) => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
        }

        reader.addEventListener("load", function () {
            resolve(reader.result);
        }, false);
    })
}

// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const emailRegex = /^(?=.{1,256})(?=.{1,64}@.{1,255})(?=.{1,64}@.{1,255}\.[a-zA-Z]{2,})(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function calculateTotalWorkingDays(year, month, workingDays) {
    if (!year || !month || !workingDays || !Array.isArray(workingDays)) {
        console.error("Invalid inputs provided to calculateWorkingDays.");
        return 0;
    }

    if (typeof month === "string") {
        month = monthMap[month];
    }

    if (!month) {
        console.error("Invalid month provided.");
        return 0;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    let totalWorkingDays = 0;

    for (let day = 1; day <= daysInMonth; day++) {
        let currentDate = new Date(year, month - 1, day);
        let currentDay = currentDate.toLocaleDateString('en-US', { weekday: 'long' });


        if (workingDays.includes(currentDay)) {
            totalWorkingDays++;
        }
    }

    return totalWorkingDays;
}

export const daysWorkedSet = new Set(); // To store unique work days
export const approvedLeaveDatesSet = new Set();
export const requiredWorkingDaysWithHours = {};

export function resetWorkData() {
  daysWorkedSet.clear();
  // approvedLeaveDatesSet.clear();
  for (const key in requiredWorkingDaysWithHours) {
    delete requiredWorkingDaysWithHours[key];
  }
}

export const monthNames = {
    "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04", "May": "05", "Jun": "06",
    "Jul": "07", "Aug": "08", "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
};

export function convertToFullDate(shortDate, year, monthNumber) {

    let [monthStr, day] = shortDate.split(" ");
    let month = monthNames[monthStr];

    if (!month) {
        console.warn("Invalid leave date format:", shortDate);
        return null;
    }

    return `${year}-${month}-${day.padStart(2, '0')}`;
}

export function generateYearsArray() {
    const currentYear = new Date().getFullYear();
    const years = [];
    
    for (let i = -5; i < 5; i++) {
        years.push(currentYear + i);
    }
    
    return years;
}

export function stripeLeadingZero(value) {
    if (!value) return value;

    const stringVal = value.toString();
    const parts = stringVal.split('.');
    const whole = parts[0].replace(/^0+(?!$)/, '') || '0';
    const decimal = parts[1] || '';

    const result = decimal ? whole + '.' + decimal : whole;

    if (parseFloat(result) === 0) {
        return '';
    }

    return result;
}

  function convertTo24HourFormat(timeStr) {
    if (!timeStr) return null;
    const [time, modifier] = timeStr.split(' ');

    if (!time || !modifier) return timeStr; // Already in 24-hour format

    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
    } else if (modifier.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${minutes}`;
  }

 export  function normalizeTime(timeStr) {
    if (!timeStr) return null;

    // Try to parse directly (24-hour format)
    let date = new Date(`1970-01-01T${timeStr}`);
    if (!isNaN(date.getTime())) {
      return date.toTimeString().slice(0, 5); // "HH:mm"
    }

    // If failed, try converting from 12-hour to 24-hour format
    const converted = convertTo24HourFormat(timeStr);
    date = new Date(`1970-01-01T${converted}`);

    if (!isNaN(date.getTime())) {
      return date.toTimeString().slice(0, 5); // "HH:mm"
    }

    console.warn("Invalid time format:", timeStr);
    return null;
  }

export function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}

export function isInHourRange(decimalHour) {
    const hoursPart = Math.floor(decimalHour);
    const minutesDecimal = decimalHour - hoursPart;
    const minutesPart = Math.round(minutesDecimal * 60);

    return minutesPart >= 0 && minutesPart < 60;
}

export function formatDecimalHours(decimalHours) {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return `${hours} hrs ${minutes} mins`;
}

// src/utils/dateUtils.js

export function calculateWorkingDays(startDateStr, endDateStr, workingDays) {
  if (startDateStr === endDateStr) {
    return 1;
  }
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  if (startDate > endDate) {
    return 0;
  }
  let count = 0;

  const workingDaysNums = workingDays.map(day =>
    ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day)
  );

  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    if (workingDaysNums.includes(d.getDay())) {
      count++;
    }
  }

  return count;
}
export function isHoliday(date, holidays, userShift = null) {
  if (!date || !holidays || !holidays.length) return false;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  const isNightShiftUser = userShift && userShift.toLowerCase() === "night";
  for (const hol of holidays) {
    if (!hol.dates) continue;

    const holStart = new Date(hol.dates);
    const holYear = holStart.getFullYear();
    const holShift = (hol.shift || "General").toLowerCase();
    if (isNightShiftUser) {
      if (holShift !== "night" && holShift !== "general") continue;
    } else {
      if (holShift !== "morning" && holShift !== "general") continue;
    }

    if (hol.isRecurring) {
      if (holStart.getMonth() === month && holStart.getDate() === day) {
        return true;
      }
    } 
    else if (holYear === year && 
             holStart.getMonth() === month && 
             holStart.getDate() === day) {
      return true;
    }
    if (hol.numberOfDays && hol.numberOfDays > 1) {
      for (let i = 0; i < hol.numberOfDays; i++) {
        const holDate = new Date(holStart);
        holDate.setDate(holDate.getDate() + i);

        if (holDate.getFullYear() === year &&
            holDate.getMonth() === month &&
            holDate.getDate() === day) {
          return true;
        }
      }
    }
  }
  return false;
}
export function calculateWorkingDaysExcludingHolidays(start, end, workingDaysConfig, holidays, userShift = null) {
  let count = 0;
  const startDate = new Date(start);
  const endDate = new Date(end);

  if (startDate > endDate) return 0;

  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    if (isWorkingDay(d, workingDaysConfig) && !isHoliday(d, holidays, userShift)) {
      count++;
    }
  }
  return count;
}
function isWorkingDay(date, workingDays) {
  const workingDaysNums = workingDays.map(day =>
    ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day)
  );
  return workingDaysNums.includes(date.getDay());
}
export function parseLeaveDates(dateStr, year) {
  const parts = dateStr.split(" - ");

  if (parts.length === 2) {
    const startDate = new Date(`${parts[0]} ${year}`);
    const endDate = new Date(`${parts[1]} ${year}`);
    return { startDate, endDate };
  } else {
    const startDate = new Date(`${dateStr} ${year}`);
    return { startDate, endDate: startDate };
  }
}

/**
 * Formats an object of half-day hours into an array of readable date strings.
 * 
 * @param {Object} halfDays - Object with day numbers as keys, and hours as values.
 * @param {Number} year - The full year (e.g., 2025).
 * @param {Number} month - The month number (1 = January, 12 = December).
 * @returns {String[]} Array of formatted date strings like "07-May-2025".
 */
export function formatDaysToDateArray(halfDays = {}, year, month) {
  if (!halfDays || typeof halfDays !== 'object') return [];

  const monthNum = monthMap[month]; // Make sure this gives number like 4 for 'April'
  return Object.keys(halfDays).map(day => {
      const dayNum = parseInt(day, 10);
      const dateObj = new Date(year, monthNum - 1, dayNum); // JS months are 0-indexed
      return dateObj.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit", // <-- changed from 'long' to '2-digit'
          year: "numeric"
      }).replace(/\//g, "-"); // Convert dd/mm/yyyy to dd-mm-yyyy
  });
}

export function getTotalDaysInMonth(monthName, year) {
  const date = new Date(`${monthName} 1, ${year}`);
  const monthIndex = date.getMonth(); // Get month index from name
  const totalDays = new Date(year, monthIndex + 1, 0).getDate(); // Last day of the month
  return totalDays;
}

// form validation

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidNIC(nic) {
  const nicRegex = /^\d{5}-\d{7}-\d{1}$/;
  return nicRegex.test(nic);
}

export function isValidPhoneNumber(phone) {
  const phoneRegex = /^\+?[0-9]{10,15}$/;
  return phoneRegex.test(phone);
}

export function isValidIBAN(iban) {
  const ibanRegex = /^PK\d{2}[A-Z0-9]{20}$/;
  return ibanRegex.test(iban.replace(/\s/g, ''));
}

export function validateForm(user, isNonAdmin) {
  const errors = {};
  let isValid = true;
  console.log('Validating form with user data:', user); // Debug log

  if (!user.fullName) {
    errors.fullName = 'Full Name as per NIC is required';
    isValid = false;
  }
  if (!user.personalEmail) {
    errors.personalEmail = 'Personal Email is required';
    isValid = false;
  } else if (!isValidEmail(user.personalEmail)) {
    errors.personalEmail = 'Please enter a valid email address';
    isValid = false;
  }
  if (!user.nicNumber) {
    errors.nicNumber = 'NIC Number is required';
    isValid = false;
  } else if (!isValidNIC(user.nicNumber)) {
    errors.nicNumber = 'Please enter a valid NIC number (e.g., 12345-1234567-1)';
    isValid = false;
  }
  if (!user.dateOfBirth) {
    errors.dateOfBirth = 'Date of birth is required';
    isValid = false;
  }
  if (!isNonAdmin) {
    if (!user.designation) {
      errors.designation = 'Designation is required';
      isValid = false;
    }
    if (!user.joiningDate) {
      errors.joiningDate = 'Joining Date is required';
      isValid = false;
    }
    if (!user.grade) {
      errors.grade = 'Grade is required';
      isValid = false;
    }
    if (!user.email) {
      errors.companyEmail = 'Company Email is required';
      isValid = false;
    } else if (!isValidEmail(user.email)) {
      errors.companyEmail = 'Please enter a valid company email address';
      isValid = false;
    }
  }
  if (!user.bankName) {
    errors.bankName = 'Bank Name is required';
    isValid = false;
  }
  if (!user.iban) {
    errors.iban = 'IBAN/Account number is required';
    isValid = false;
  } else if (!isValidIBAN(user.iban)) {
    errors.iban = 'Enter a valid IBAN (e.g., PK36SCBL0000001123456702)';
    isValid = false;
  }
  if (!user.nationality) {
    errors.nationality = 'Nationality is required';
    isValid = false;
  }
  if (!user.maritalStatus) {
    errors.maritalStatus = 'Marital Status is required';
    isValid = false;
  }
  if (!user.currentAddress) {
    errors.currentAddress = 'Current Address is required';
    isValid = false;
  }
  if (!user.permanentAddress) {
    errors.permanentAddress = 'Permanent Address is required';
    isValid = false;
  }
  if (!user.phoneNumber) {
    errors.contactNumber = 'Contact Number is required';
    isValid = false;
  } else if (!isValidPhoneNumber(user.phoneNumber)) {
    errors.contactNumber = 'Please enter a valid contact number (10-15 digits)';
    isValid = false;
  }
  if (!user.emergencyContactName) {
    errors.emergencyContactName = 'Emergency Contact Name & Relationship is required';
    isValid = false;
  }
  if (!user.emergencyContactNumber) {
    errors.emergencyContactNumber = 'Emergency Contact Number is required';
    isValid = false;
  } else if (!isValidPhoneNumber(user.emergencyContactNumber)) {
    errors.emergencyContactNumber = 'Please enter a valid emergency contact number (10-15 digits)';
    isValid = false;
  }
  if (!user.nicImageUrl) {
    errors.nicImageUrl = 'NIC Picture is required';
    isValid = false;
  }

  console.log('Validation result:', { isValid, errors }); // Debug log
  return { isValid, errors };
}
export function validateDocuments(user, errors) {
  let isValid = true;
  if (!user.certificateUrl) {
    errors.certificateUrl = 'Academic certificate/Experience letter is required';
    isValid = false;
  }
  if (!user.salarySlipUrl) {
    errors.salarySlipUrl = 'Salary Slip is required';
    isValid = false;
  }
  return { isValid, errors };
}
export function convertAmountToWords(num) {
  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  num = Math.floor(num || 0);
  if (num === 0) return "Zero";

  function convertLessThanOneThousand(n) {
      if (n === 0) return "";
      if (n < 10) return units[n];
      if (n < 20) return teens[n - 10];
      if (n < 100) {
          return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");
      }
      return units[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " and " + convertLessThanOneThousand(n % 100) : "");
  }

  function convert(n) {
      if (n === 0) return "Zero";
      let result = "";
      
      // Handle lakhs
      if (n >= 100000) {
          const lakhs = Math.floor(n / 100000);
          result += convertLessThanOneThousand(lakhs) + " Lakh";
          n %= 100000;
          if (n > 0) result += " ";
      }
      
      // Handle thousands
      if (n >= 1000) {
          const thousands = Math.floor(n / 1000);
          result += convertLessThanOneThousand(thousands) + " Thousand";
          n %= 1000;
          if (n > 0) result += " ";
      }
      
      // Handle remainder
      if (n > 0) {
          result += convertLessThanOneThousand(n);
      }
      
      return result;
  }

  return convert(num);
}

export const padDay = (day) => String(day).padStart(2, '0');

export const formatHoursDetails = (
  data,
  formatToHoursMinutes,
  month,
  year
) => {
  if (!data) return [];
  return Object.entries(data || {}).map(([day, hours]) => {
    const time = formatToHoursMinutes(hours);
    return `${padDay(day)}-${month}-${year}: ${time}`;
  });
};

export const getRemainingHours = (
  data,
  empTotalHours,
  skipZero = false
) => {
  return Object.entries(data || {}).reduce((acc, [day, value]) => {
    const diff = empTotalHours - Number(value);
    if (skipZero && diff === 0) return acc;
    acc[day] = diff;
    return acc;
  }, {});
};

export const getAboveHalfDayExtra = (data, threshold = 5) => {
  const result = {};

  for (const [key, value] of Object.entries(data || {})) {
    if (value > threshold) {
      const extra = value - threshold;
      result[key] = extra;
    }
  }

  return result;
};


export const formatAndFilterZeroMins = (
  data,
  formatToHoursMinutes,
  month,
  year
) => {
  return Object.entries(data || {})
    .map(([day, value]) => {
      const formatted = formatToHoursMinutes(value);
      return { day, formatted };
    })
    .filter(({ formatted }) => formatted !== '0 min')
    .map(({ day, formatted }) => `${padDay(day)}-${month}-${year}: ${formatted}`);
};

export const calculateTotalHoursAndMinutes = (data) => {
  console.log("data",data)
  let totalMinutes = 0;

  Object.values(data || {}).forEach((val) => {
    const decimal = Number(val); // e.g. 4.510185
    if (!isNaN(decimal)) {
      totalMinutes += decimal * 60;
    }
  });

  const isNegative = totalMinutes < 0;
  const absMinutes = Math.round(Math.abs(totalMinutes));
  const hrs = Math.floor(absMinutes / 60);
  const mins = absMinutes % 60;

  return {
    hrs,
    mins,
    isNegative,
    text: `${hrs} hr${hrs !== 1 ? 's' : ''} ${mins} min${mins !== 1 ? 's' : ''}`,
    color: isNegative ? 'red' : 'green',
  };
};

export const sumHoursAndMinutes = (a, b) => {
  let totalHrs = a.hrs + b.hrs;
  let totalMins = a.mins + b.mins;

  // Convert minutes to hours if over 60
  if (totalMins >= 60) {
    totalHrs += Math.floor(totalMins / 60);
    totalMins = totalMins % 60;
  }

  return {
    hrs: totalHrs,
    mins: totalMins,
    text: `${totalHrs} hrs ${totalMins} mins`,
  };
};
  
export default {
    fileToDataURL,
    emailRegex
}



// WEBPACK FOOTER //
// ./src/assets/config/helpers.js